<template>
    <div id="app">
        <router-view/>
        
    </div>
</template>

<script>

    import "./assets/css/style.css";

    export default {
        data: function () {
            return {
                addrData: []
            }
        },
        created(){
            const _this = this;
            // 在页面加载时读取sessionStorage
            if (sessionStorage.getItem('store')) {
                _this.$store.replaceState(Object.assign({}, _this.$store.state, JSON.parse(sessionStorage.getItem('store'))))
            }
            // 在页面刷新时将store保存到sessionStorage里
            window.addEventListener('beforeunload', () => {
                sessionStorage.setItem('store', JSON.stringify(_this.$store.state))
            })
        },
        mounted() {
            
        },
        methods: {
        }
    }

</script>
<style>
   body{
       font-family:"Microsoft YaHei","微软雅黑", "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB",Arial,sans-serif;
   } 
    html,body { 
        margin: 0; 
        padding:0; 
        height: 100%; 
    } 
   .addr{
       margin-right:.1rem;
   }
   .listw01-item-pic img,.listw02-item-pic img{
       max-width:100%;
       min-height:100%;
   }
   #app{
        /* min-height:100%; 
        height: auto !important;  */
        height: 100%; /*IE6不识别min-height*/ 
        position: relative; 
   } 
    strong{
        font-weight:bold!important;
    } 
</style>